import React, { useEffect, useState, useContext } from 'react';
import { isMobileDevice } from 'common/utilities/utils';
import { useSelector } from 'react-redux';
import { HEADER_TITLE } from '../constants/offersAndDealsConstants';
import DealsAndOffersCard from '../Presentation/DealsAndOffersCard';
import DealsAndOffersHeader from '../Presentation/DealsAndOffersHeader';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { UserOrderContext } from 'context/context';
import { ClearCartModule } from 'organisms/ClearCartModule/Container/ClearCartComponent';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

export const DealsAndOffersLandingPage = props => {
  const { onStartOrderClick, copyCoupon } = props;
  const [isMobile, setIsMobile] = useState(isMobileDevice(window.innerWidth));
  const appStateReducer = useSelector(data => data.appStateReducer);
  const { userStatus = {} } = appStateReducer;
  const { localized = false, loggedIn = false } = userStatus;
  const { userOrderState } = useContext(UserOrderContext);
  const { offer_deals_banner } = IMAGE_PATH;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  /**
   * useEffect to add and cleanup of window resize event
   */
  useEffect(() => {
    window.addEventListener('resize', windowResized);
    return () => {
      window.removeEventListener('resize', windowResized);
    };
  });

  /**
   * Handler function for resizing of window
   */
  const windowResized = () => {
    setIsMobile(isMobileDevice(window.innerWidth));
  };

  return (
    <div className='deals-offer-container-section'>
      <div
        style={{
          backgroundImage: `url(${offer_deals_banner})`,
        }}
        className='deals-header-image'
      >
        <h2 className='deals-image-text'>{translateWithI18Next(HEADER_TITLE)}</h2>
      </div>
      <div className='deals-offers-container'>
        <DealsAndOffersHeader isLoggedIn={loggedIn} isMobile={isMobile} isLocalized={localized} />
        <DealsAndOffersCard
          onStartOrderClick={onStartOrderClick}
          copyCoupon={copyCoupon}
          isLoggedIn={loggedIn}
          isLocalized={localized}
          {...props}
        />
      </div>
      {userOrderState.showCartClearAlert ? <ClearCartModule /> : null}
    </div>
  );
};
